<template>
    <v-menu transition="slide-y-transition" v-model="showmenu" rounded :close-on-content-click="false" app clipped offset-y left aria-label="Notifications menu">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="mr-2" v-bind="attrs" v-on="on" @click="showmenu = true" :aria-label="menuButtonAriaLabel" :aria-expanded="showmenu.toString()" aria-haspopup="menu">
                <v-badge id="badge" small :content="messages" :value="messages" color="darkgreen" overlap>
                    <v-icon aria-hidden="true" color="grey darken-2">mdi-bell</v-icon>
                </v-badge>
                <span class="sr-only" aria-live="polite">{{ menuBadgeAnnouncement }}</span>
            </v-btn>
        </template>

        <v-list id="notificationlist" v-if="notifications.length" role="menu" aria-label="Latest notifications">
            <v-list-item
                v-for="(notification, index) in notifications"
                :key="index"
                class="notification ml-auto"
                @click="clickNotification(notification)"
                role="menuitem"
                :aria-label="notificationAriaLabel(notification)">
                <v-list-item-title>
                    <v-row>
                        <div class="mx-3 py-auto my-auto">
                            <v-avatar color="#f7f7f7">
                                <v-icon :color="notification.icon_color" aria-hidden="true">{{ notification.icon }}</v-icon>
                            </v-avatar>
                        </div>
                        <v-col class="py-auto my-auto nofitificationtext">
                            <v-row
                                ><span class="listname">{{ notification.listname }}</span></v-row
                            >
                            <v-row class="message">
                                {{ notification.message }}
                            </v-row>
                            <v-row class="message" v-if="notification.message_2">
                                {{ notification.message_2 }}
                            </v-row>
                            <v-row class="date">
                                {{ notification.date }}
                            </v-row>
                        </v-col>
                        <div class="mx-3 py-auto my-auto">
                            <v-btn v-if="notification.type !== '1'" icon class="ml-auto" @click.stop="deleteNotification(notification.id)" aria-label="Dismiss notification">
                                <v-icon color="primary" aria-hidden="true">mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-row>
                    <v-progress-linear
                        :class="notifications.length > 1 ? 'mb-2' : ''"
                        v-if="notification.type == '1'"
                        v-model="notification.progress"
                        :indeterminate="notification.indeterminate === true"
                        query
                        rounded
                        role="progressbar"
                        :aria-valuenow="notification.progress"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        aria-label="Progress notification"></v-progress-linear>
                    <hr id="notificationline" class="mr-2" v-if="notifications.length > 1 && index != notifications.length - 1" />
                </v-list-item-title>
            </v-list-item>
        </v-list>

        <v-list id="notificationlist" v-else role="menu" aria-label="No notifications">
            <v-list-item role="menuitem">
                <v-list-item-title>
                    <v-row>
                        <v-col class="py-auto my-auto">
                            <v-icon :color="noNotifications.icon_color" aria-hidden="true">{{ noNotifications.icon }}</v-icon>
                        </v-col>
                        <v-col class="py-auto my-auto nofitificationtext">
                            {{ noNotifications.message }}
                        </v-col>
                    </v-row>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import sound from "../assets/audio/notification-sound.mp3"
    export default {
        name: "Notifications",
        props: {},
        components: {},
        data: () => ({
            messages: 0,
            showmenu: false,
            notifications: [],
            noNotifications: {
                message: "No notifications here for you!",
                icon: "mdi-bell-off",
                icon_color: "darkgreen"
            }
        }),
        computed: {
            menuButtonAriaLabel() {
                return this.messages ? `Open notifications, ${this.messages} unread` : "Open notifications"
            },
            menuBadgeAnnouncement() {
                return this.messages ? `${this.messages} unread notifications` : "No unread notifications"
            }
        },
        methods: {
            notificationAriaLabel(notification) {
                return `${notification.listname}. ${notification.message}${notification.message_2 ? " " + notification.message_2 : ""}. Received on ${notification.date}.`
            },
            playNotificationSound() {
                const audio = new Audio(sound)
                audio.play().catch(() => {})
            },
            createNotification(data) {
                let notificationObject
                if (data.type == "0") {
                    //type 0 = error
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-alert-circle",
                        icon_color: "red",
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications.splice(index, 1)
                            this.messages--
                        }
                    }
                } else if (data.type == "1") {
                    //type 1 = branddashboard is creating
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-clock",
                        icon_color: "orange",
                        progress: 0,
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                } else if (data.type == "2") {
                    //type 1 = branddashboard created
                    // remove id and push new notification
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications.splice(index, 1)
                            this.messages--
                        }
                    }
                    notificationObject = {
                        type: data.type,
                        message: data.message,
                        icon: "mdi-comment-check",
                        icon_color: "green",
                        listname: data.listname,
                        date: this.getDateTime(),
                        id: data.id
                    }
                } else if (data.type == "3") {
                    //type 3 = progress update
                    console.log(this.notifications)
                    for (let index = 0; index < this.notifications.length; index++) {
                        if (this.notifications[index].id == data.id) {
                            this.notifications[index].progress = data.progress
                            console.log(this.notifications)
                        }
                    }
                    return null
                    // notificationObject = {
                    //   message: data.message,
                    //   icon: 'mdi-comment-check',
                    //   icon_color: 'green',
                    //   listname: data.listname,
                    //   date: this.getDateTime(),
                    //   id: Math.floor(Math.random() * 999)
                    // }
                }
                return notificationObject
            },
            onLocalExportStart(data) {
                if (!data || !data.id) return
                // evtl. bestehende Notification mit gleicher id entfernen
                const existing = this.notifications.findIndex((n) => n.id == data.id)
                if (existing !== -1) {
                    this.notifications.splice(existing, 1)
                    this.messages--
                }
                this.notifications.unshift({
                    type: "1", // Progress-Bar, kein Close-Button während des Laufs
                    message: data.message || "Preparing export…",
                    icon: "mdi-download",
                    icon_color: "orange",
                    progress: 0,
                    indeterminate: true, // Gesamtgröße unbekannt -> laufender (unbestimmter) Balken
                    listname: data.listname || "Export",
                    date: this.getDateTime(),
                    id: data.id
                })
                this.messages++
                this.showmenu = true
            },
            onLocalExportProgress(data) {
                if (!data || !data.id) return
                const n = this.notifications.find((x) => x.id == data.id)
                if (!n) return
                if (typeof data.progress === "number") n.progress = data.progress
                if (data.message) n.message = data.message
            },
            onLocalExportDone(data) {
                if (!data || !data.id) return
                const n = this.notifications.find((x) => x.id == data.id)
                if (!n) return
                n.type = "export_done" // Progress-Bar aus, Close-Button an
                n.icon = "mdi-check-circle"
                n.icon_color = "green"
                n.message = data.message || "Export finished"
                n.date = this.getDateTime()
            },
            onLocalExportError(data) {
                if (!data || !data.id) return
                const n = this.notifications.find((x) => x.id == data.id)
                if (!n) return
                n.type = "export_error"
                n.icon = "mdi-alert-circle"
                n.icon_color = "red"
                n.message = data.message || "Export failed"
                n.date = this.getDateTime()
            },
            getDateTime() {
                let dateTime = new Date()
                let month = dateTime.getMonth() + 1
                let day = dateTime.getDate()
                let hours = dateTime.getHours()
                let minutes = dateTime.getMinutes()
                return day + "." + month + " | " + hours + ":" + minutes
            },
            clickNotification(notification) {
                if (notification.type == "2") {
                    this.$router.push("/brand-index/" + notification.listname)
                }
                if (notification.updateinfo) {
                    this.$emit("showUpdateInfo")
                }
            },
            deleteNotification(id) {
                for (let index = 0; index < this.notifications.length; index++) {
                    if (this.notifications[index].id == id) {
                        this.notifications.splice(index, 1)
                        this.messages--
                    }
                }
                this.showmenu = false
            }
        },
        mounted() {
            this.$socket.on("getNotification", (data) => {
                //console.log(data.message)

                let notificationObject = this.createNotification(data)
                if (notificationObject) {
                    this.notifications.unshift(notificationObject)
                    this.showmenu = false
                    this.messages++
                    this.showmenu = true
                    this.playNotificationSound()
                }
            })

            // Client-seitige Fortschritts-Notifications (z.B. großer CSV-Export).
            this.$root.$on("localExportStart", this.onLocalExportStart)
            this.$root.$on("localExportProgress", this.onLocalExportProgress)
            this.$root.$on("localExportDone", this.onLocalExportDone)
            this.$root.$on("localExportError", this.onLocalExportError)
            // this.$socket.on("showReloadmessage", (data) => {
            //     console.log("Refreshing frontend initiated...showing message")
            //     this.showUpdateMessage = true
            //     setInterval(() => {
            //         if (this.timer > 0) {
            //             this.timer--
            //         }
            //     }, 1000)
            // })
            // this.$socket.on("reloadFrontend", (data) => {
            //     console.log("Refreshing frontend...")
            //     this.$router.go()
            // })
        },
        beforeDestroy() {
            this.$root.$off("localExportStart", this.onLocalExportStart)
            this.$root.$off("localExportProgress", this.onLocalExportProgress)
            this.$root.$off("localExportDone", this.onLocalExportDone)
            this.$root.$off("localExportError", this.onLocalExportError)
        }
    }
</script>

<style scoped>
    .notification:hover {
        background-color: #e9e9e9;
    }
    .nofitificationtext {
        font-family: Nunito;
    }
    #notificationline {
        margin-left: 60px !important;
        border-radius: 5px;
        border: 1px solid rgb(228, 228, 228);
    }
    .message {
        font-size: 0.9em;
    }
    .date {
        padding-top: 2px;
        font-size: 0.6em;
    }
    .listname {
        font-weight: bold;
        font-size: 0.9em;
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0 0 1px 1px);
        white-space: nowrap;
        border: 0;
    }
</style>
